import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Chip from '@mui/material/Chip';
import { Button, Typography } from '@raisin/components-lib';

export const OfferCard = styled(Card)({
  cursor: 'pointer',
  boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.1)',
  borderRadius: 8,
});

export const ProductItem = styled(Grid)(({ theme, $isLongText }) => ({
  [theme.breakpoints.down('lg')]: {
    display: $isLongText ? 'none' : 'block',
  },
}));

export const ProductItemRow = styled(Grid)(({ theme, $isLongText }) => ({
  display: 'none',
  [theme.breakpoints.down('lg')]: {
    display: $isLongText ? 'block' : 'none',
    margin: theme.spacing(2, 0, 3),
    paddingLeft: theme.spacing(2),
  },
}));

export const HoverContainer = styled('div')(({ theme, $disableHoverEffect }) => ({
  '&:hover': {
    backgroundColor: $disableHoverEffect ? 'inherit' : theme.palette.blue10.main,
  },
}));

export const GridContainer = styled(Grid)(({ theme }) => ({
  alignItems: 'center',
  padding: theme.spacing(6),
  justifyContent: 'space-between',

  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(4, 2.5),
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
}));

export const RateGridItem = styled(Grid)(({ theme, $hasMinHeight }) => ({
  [theme.breakpoints.down('lg')]: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minHeight: $hasMinHeight ? 60 : 'unset',
  },
}));

export const ProductTypeChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette?.['noticeAccount100'].main,
  color: theme.palette.white.main,
  fontSize: theme.typography.body1.fontSize,
  fontWeight: theme.typography.subtitle1.fontWeight,
  borderRadius: 4,
  height: 24,

  '&.overnight': {
    backgroundColor: theme.palette?.['overnightMoney100'].main,
  },

  '&.term': {
    backgroundColor: theme.palette?.['fixedTerm100'].main,
  },

  '& span': {
    paddingLeft: theme.spacing(2.25),
    paddingRight: theme.spacing(2.25),

    [theme.breakpoints.down('lg')]: {
      padding: theme.spacing(0.5, 1, 0.5, 2),
      fontSize: theme.typography.body2.fontSize,
    },
  },
}));

export const FieldLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.black60.main,
  marginBottom: theme.spacing(1),

  [theme.breakpoints.up('lg')]: {
    display: 'none',
  },
}));

export const ProductInfo = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.subtitle2.fontWeight,
}));

export const DepositGuaranteeColumn = styled('span')(({ theme, $isGBR }) => ({
  display: 'flex',
  alignItems: 'center',

  [theme.breakpoints.down('lg')]: {
    minHeight: $isGBR ? 30 : 'unset',
    flexWrap: $isGBR ? 'wrap' : 'unset',
  },
}));

export const DepositGuaranteeImg = styled('img')(({ theme }) => ({
  maxWidth: 100,
  maxHeight: 70,
  display: 'block',
  marginLeft: theme.spacing(2),

  [theme.breakpoints.down('lg')]: {
    maxWidth: 65,
    maxHeight: 30,
  },
}));

export const OrderButton = styled(Button)(({ theme }) => ({
  marginLeft: 'auto',

  [theme.breakpoints.down('lg')]: {
    width: '100%',
  },
}));

export const CtaContainerGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),

  [theme.breakpoints.down('lg')]: {
    display: 'block',
  },
}));

export const LogoLink = styled('a')``;
